import axiosClient from "api/axiosClient";
import API_MAP from "constants/api";

export const functionService = {
    getFunctionScope: async (functionCode) => {
        try {
            const res = await axiosClient.get(API_MAP.FUNCTION.GET_FUNCTION_SCOPE(functionCode));

            return res;
        } catch (error) {
            console.log(error);
        }
    }
}
